"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersBanner = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, (data === null || data === void 0 ? void 0 : data.slug) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.providerImage },
        react_1.default.createElement("object", { data: "/img/providers/".concat(data.slug, ".svg"), type: "image/png" },
            react_1.default.createElement("img", { src: "/img/providers/default.svg", alt: data === null || data === void 0 ? void 0 : data.title })))) : null));
};
exports.default = ProvidersBanner;
